var map = {
	"./AI-Assistant.svg": 58469,
	"./Countries.svg": 9186,
	"./Currencies.svg": 71925,
	"./Directory.svg": 6469,
	"./Organization.svg": 92377,
	"./Organizations.svg": 27832,
	"./Salaries.svg": 71738
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 21690;